import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  ProductVariantsMatrixState,
  ProductVariantsMatrixType,
} from 'b2b-apps/shop/product/redux/productVariantsMatrix/types';

const getState = (state: State): ProductVariantsMatrixState => state.product.productVariantsMatrix;

const getProductVariantsMatrix = (state: State): ProductVariantsMatrixState => getState(state) || {};

const getProductVariantsMatrixBySku = (
  state: State,
  sku: string,
): RemoteRecord<ProductVariantsMatrixType> => new RemoteRecord(getProductVariantsMatrix(state)[sku]);

export {
  getProductVariantsMatrix,
  getProductVariantsMatrixBySku,
  getState,
};
